<ng-container *ngIf="isCookieBotEnabled">
  <ngx-cookiebot-declaration hidden></ngx-cookiebot-declaration>
</ng-container>
